import { useMemo } from 'react'

import { useQuery } from '@tanstack/react-query'

import axios from 'axios'

import { getAssetByTypeAndSource } from 'Pods/ThreeDStudio/Shared/Utils/getAssetByTypeAndSource'
import { isSourceGenerationModel } from 'Pods/ThreeDStudio/Shared/Utils/isSourceGenerationModel'

function useGetVariations(sessionId) {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['variations', String(sessionId)],
    queryFn: async () => {
      const { data: responseData } = await axios.get('/api/internal/generator/runs', {
        params: { generator_session_id: sessionId },
      })

      return responseData.data || []
    },
    enabled: sessionId != null,
  })

  const variations = useMemo(() =>
    (data ?? [])
      .map((item) => ({ ...item.attributes, id: item.id }))
      .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt)),
    [data],
  )

  const uploadedAsset = useMemo(() => (
    variations
      .map(variation => getAssetByTypeAndSource(variation.inputAssets, '3d_model', 'user_upload'))
      .find(asset => asset.fileUrl) ?? null
  ), [variations])

  // The original is the session's base generation, identified by its model (text-to-3d /
  // image-to-3d) rather than by position: an upload-originated session has none, and neither
  // does one whose base generation was deleted, so no remaining run is ever promoted into the
  // unnumbered, uncounted slot behind the user's back.
  const originalRunId = useMemo(() => (
    variations.find(variation => isSourceGenerationModel(variation.providerModelId))?.id ?? null
  ), [variations])

  const variationsCount = originalRunId == null ? variations.length : variations.length - 1

  return { variations, uploadedAsset, originalRunId, variationsCount, isLoading, isError }
}

export default useGetVariations
